import PropTypes from "prop-types";

import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { withTranslation } from "react-i18next";
import DialogBoxComponent from "../Utility/Helpers/DialogBoxComponent";
//redux
import { useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { DIALOG_TYPE } from "../Utility/Helpers/constants";
// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo-ppm.png";
import { CopyrightComponent } from 'ppm-skin'
import UsersRepository from "pages/Users/repository/users-repository";
import { PARAMETERS_API_URL } from "../../helpers/api-urls";
const ForgetPasswordPage = props => {
  const navigate = useNavigate();
  const [dialog, setDialog] = React.useState({
    show: false,
    onConfirm: () => {},
    handleClose: () => {},
    message: "",
    type: DIALOG_TYPE.ALERT
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      console.log("test", values)
      UsersRepository.lostPassword(values.email).then((response) => {
        console.log("response", response)
        const currentDialog = {
          show: true,
          handleClose: () => {
            navigate('/login');
          },
          onConfirm: () => {
            navigate('/login');
          },
          message: props.t("REQUEST_SENT_PLEASE_CHECK_YOUR_EMAIL"),
          title: '',
          type: DIALOG_TYPE.SUCCESS
        };
        setDialog(currentDialog);
      }).catch((error) => {
        console.log("error", error)
      })
    }
  });

  const { forgetError, forgetSuccessMsg } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }));

  const toggleDialogModal = () => {
    setDialog({...dialog, show: false})
    navigate('/login');
  };

  return (
    <React.Fragment>
        <title>
          {props.t("FORGET_PASSWORD")}
        </title>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Skote.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">{props.t("EMAIL")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                          >
                            {props.t("RESET")}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <div className="text-center">
                   {new Date().getFullYear()}<CopyrightComponent apiUrl={PARAMETERS_API_URL}/>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <DialogBoxComponent
        handleClose={() => toggleDialogModal()}
        handleConfirm={() => dialog.onConfirm()}
        show={dialog.show}
        type={dialog.type}
        message={dialog.message}
      />
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withTranslation()(ForgetPasswordPage);